import React from 'react';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();

  const handleEmailLogin = () => {
    // Email/password login logic yahan rahega
    onLogin('student'); // ya 'tutor' based on logic
  };

  const handleOTPLogin = () => {
    navigate('/otp-login'); // ✅ Redirect to OTP login
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '400px', margin: 'auto', textAlign: 'center' }}>
      <h2>Login</h2>

      {/* Existing login form (email/password etc.) */}
      <button
        onClick={handleEmailLogin}
        style={{
          padding: '10px 20px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          marginBottom: '1rem',
          cursor: 'pointer',
        }}
      >
        Login with Email
      </button>

      <br />

      {/* ✅ OTP Login button */}
      <button
        onClick={handleOTPLogin}
        style={{
          padding: '10px 20px',
          backgroundColor: '#2196F3',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        Login with Phone OTP
      </button>
    </div>
  );
};

export default Login;
